module.exports = "/lopo_success-205f8f4549d0563f94667aba7747f4c1.svg";